const setCookie = (name, value) => {
    document.cookie = `${name}=${value || ''}; path=/`;
};

const getCookie = name => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

export default function initNavigation() {
    const $backdrop = document.createElement('div');
    $backdrop.classList.add('main-navigation-backdrop');

    const hideNavigation = () => {
        document
            .querySelectorAll('.main-navigation .is-active')
            .forEach($active => $active.classList.remove('is-active'));
        setTimeout(() => {
            document
                .querySelectorAll('.main-navigation .is-shifted')
                .forEach($shifted => $shifted.classList.remove('is-shifted'));
        }, 80);

        $backdrop.classList.remove('is-visible');
    };

    const hideLanguageSwitcher = () => {
        document.body.classList.remove('is-language-switcher-visible');
        document.querySelector('.js-toggle-language-navigation').classList.remove('is-active');
    };

    const hideAccountSelector = () => {
        document.body.classList.remove('is-account-selector-visible');
        document.querySelector('[data-account-selector]').parentElement.classList.remove('is-active');
    };

    const hideUserDropDown = () => {
        let userMenus = document.querySelectorAll('.js-user-menu');
        userMenus.forEach($userMenu => {
            if ($userMenu !== undefined && $userMenu !== null) {
                $userMenu.classList.remove('is-active');
            }

            let headerDropDownUser = $userMenu.parentElement.getElementsByClassName('header-drop-down-user');
            if (headerDropDownUser !== undefined && headerDropDownUser !== null) {
                headerDropDownUser[0].classList.remove('is-visible');
            }
        });

        if (
            document.body.classList.contains('is-user-drop-down-visible') !== undefined &&
            document.body.classList.contains('is-user-drop-down-visible') !== null
        ) {
            document.body.classList.remove('is-user-drop-down-visible');
        }
    };

    const insertAfter = (referenceNode, newNode) => {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    };

    insertAfter(document.getElementById('banner'), $backdrop);

    const $links = document.querySelectorAll('.main-navigation > ul > li > a');
    $links.forEach($link => {
        $link.addEventListener('click', event => {
            if ($link.classList.contains('has-children')) {
                event.preventDefault();
                $backdrop.classList.add('is-visible');
            }

            const $parent = $link.closest('li');
            if ($parent.classList.contains('is-active')) {
                $parent.classList.remove('is-active');
                $backdrop.classList.remove('is-visible');

                if ($parent.querySelectorAll('.is-active')) {
                    setTimeout(() => {
                        $parent.querySelectorAll('.is-active') &&
                            $parent
                                .querySelectorAll('.is-active')
                                .forEach($active => $active.classList.remove('is-active'));
                    }, 80);
                }

                if ($parent.querySelector('.is-shifted')) {
                    setTimeout(() => {
                        $parent.querySelector('.is-shifted') &&
                            $parent.querySelector('.is-shifted').classList.remove('is-shifted');
                    }, 80);
                }
                return;
            }

            document
                .querySelectorAll('.main-navigation .is-active')
                .forEach($active => $active.classList.remove('is-active'));
            document
                .querySelectorAll('.main-navigation .is-shifted')
                .forEach($shifted => $shifted.classList.remove('is-shifted'));

            $parent.classList.add('is-active');
        });
    });

    const $subLinks = document.querySelectorAll('.main-navigation > ul ul > li > a');
    $subLinks.forEach($link => {
        $link.addEventListener('click', event => {
            if ($link.classList.contains('has-children')) {
                event.preventDefault();
            }

            const $parent = $link.closest('li');
            const $parentList = $link.closest('ul');

            if ($parent.classList.contains('is-active')) {
                $parent.classList.remove('is-active');
                $parentList.classList.remove('is-shifted');
                return;
            }

            $parentList.querySelectorAll('.is-active').forEach($active => $active.classList.remove('is-active'));

            $parent.classList.add('is-active');
            if (!$parentList.classList.contains('is-shifted') && $parent.querySelector('ul')) {
                $parentList.classList.add('is-shifted');
            } else if (!$link.closest('li').querySelector('ul')) {
                $link.closest('ul').classList.remove('is-shifted');
            }
        });
    });

    const $mobileToggle = document.querySelector('.js-toggle-mobile-navigation');
    $mobileToggle.addEventListener('click', event => {
        event.preventDefault();

        if (document.body.classList.contains('is-mobile-navigation-visible')) {
            document.body.classList.remove('is-mobile-navigation-visible');
            $mobileToggle.classList.remove('is-active');
        } else {
            document.body.classList.add('is-mobile-navigation-visible');
            $mobileToggle.classList.add('is-active');
        }
    });

    const $langToggle = document.querySelector('.js-toggle-language-navigation');
    $langToggle.addEventListener('click', event => {
        event.preventDefault();

        if (document.body.classList.contains('is-language-switcher-visible')) {
            document.body.classList.remove('is-language-switcher-visible');
            $langToggle.classList.remove('is-active');
        } else {
            document.body.classList.add('is-language-switcher-visible');
            $langToggle.classList.add('is-active');
        }
    });

    const $accountSelector = document.querySelector('[data-account-selector]');
    $accountSelector?.addEventListener('click', event => {
        event.preventDefault();
        const isVisible = document.body.classList.contains('is-account-selector-visible');
        if (!isVisible) {
            document.body.classList.add('is-account-selector-visible');
        }
    });

    let userMenus = document.querySelectorAll('.js-user-menu');
    userMenus.forEach($userMenu => {
        $userMenu.addEventListener('click', event => {
            event.preventDefault();
            const $dropDownContainer = $userMenu.parentElement.getElementsByClassName('header-drop-down-user');
            if (document.body.classList.contains('is-user-drop-down-visible')) {
                hideUserDropDown();
            } else {
                event.currentTarget.classList.add('is-active');
                $dropDownContainer[0].classList.add('is-visible');
                document.body.classList.add('is-user-drop-down-visible');
            }
        });
    });

    document.addEventListener('click', event => {
        const $mainNavigation = document.querySelector('.main-navigation');
        if ($mainNavigation != null && !$mainNavigation.contains(event.target)) {
            hideNavigation();
        }

        const $languageSwitcher = document.querySelector('.language-switcher');
        if (
            $languageSwitcher != null &&
            !$languageSwitcher.contains(event.target) &&
            !event.target.classList.contains('js-toggle-language-navigation')
        ) {
            hideLanguageSwitcher();
        }

        const $accountSelector = document.querySelector('[data-account-selector]');
        if (
            $accountSelector &&
            !$accountSelector.contains(event.target) &&
            !event.target.classList.contains('account-selector')
        ) {
            hideAccountSelector();
        }

        let userMenus = document.querySelectorAll('.js-user-menu');
        userMenus.forEach($userMenu => {
            let $headerDropDownUser = $userMenu.parentElement.getElementsByClassName('header-drop-down-user');
            if (
                $userMenu !== undefined &&
                $userMenu !== null &&
                $headerDropDownUser !== undefined &&
                $headerDropDownUser !== null &&
                $headerDropDownUser[0] !== undefined &&
                $headerDropDownUser[0] !== null
            ) {
                if (!$userMenu.contains(event.target) && $headerDropDownUser[0].classList.contains('is-visible')) {
                    hideUserDropDown();
                }
            }
        });
        const $headerCart = document.querySelector('.header-cart');
        const $headerDropDownCart = document.querySelector('.header-drop-down-cart');
        const $quickOrder = document.querySelector('.header-drop-down-quickorder');

        if (
            $headerCart != null &&
            $headerCart !== undefined &&
            $headerDropDownCart != null &&
            !$quickOrder?.contains(event.target) &&
            $headerDropDownCart !== undefined
        ) {
            if (!$headerCart.contains(event.target) && $headerDropDownCart.classList.contains('is-visible')) {
                $headerCart.click();
            }
        }
    });

    document.addEventListener('keyup', event => {
        if (event.key === 'Escape') {
            hideNavigation();
            hideLanguageSwitcher();
            hideUserDropDown();
            const $headerCart = document.querySelector('.header-cart');
            const $headerDropDownCart = document.querySelector('.header-drop-down-cart');

            if ($headerDropDownCart?.classList.contains('is-visible')) {
                $headerCart.click();
            }
        }
    });

    const changeAccSelectIcon = () => {
        document.querySelector('.btn-account-selector .sticker').innerHTML =
            `<svg class="icon-document" width="24px" height="24px"><use xlink:href="#icon-account-switch"></use></svg>`;
    };
    const changeAccSelectPopup = () => {
        if (document.querySelector('.account-selector-dropdown-menu').classList.contains('show')) {
            setTimeout(() => {
                const ordersTable = document.querySelector('.account-selector-fragment .orders-table');
                if (ordersTable) ordersTable.classList.remove('table-striped');
            }, 500);
        }
    };
    const changeIconsInterval = setInterval(() => {
        if (document.querySelector('.btn-account-selector')) {
            changeAccSelectIcon();
            document.querySelector('.btn-account-selector').addEventListener('click', changeAccSelectPopup);
            clearInterval(changeIconsInterval);
        }
    }, 500);

    function initChinaPopup() {
        const $chinaPopup = document.querySelector('.china-pop-up');
        const $closeBtn = $chinaPopup?.querySelector('.popup-close');

        if ($chinaPopup) {
            if (getCookie('chinaPopupClosed') !== 'true') {
                $chinaPopup.classList.add('is-visible');
            }

            if ($closeBtn && !$closeBtn.dataset.bound) {
                $closeBtn.dataset.bound = 'true';
                $closeBtn.addEventListener('click', () => {
                    setCookie('chinaPopupClosed', 'true');
                    $chinaPopup.classList.remove('is-visible');
                });
            }
        }
    }

    document.addEventListener('DOMContentLoaded', initChinaPopup);

    if (typeof Liferay !== 'undefined' && Liferay.on) {
        Liferay.on('endNavigate', initChinaPopup);
    }
}
